import { Grid, Tooltip } from '@mui/material';
import ServiceProfileLink from 'Components/Shared/ServiceProfileLink';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import useTranslate from 'Hooks/useTranslate';

interface Props {
  serviceSubscription: IServiceSubscription;
}

function CellService(props: Readonly<Props>) {
  const ts = useTranslate();
  const { serviceSubscription } = props;

  if(serviceSubscription.isAvailable === false){
    return(
      <Grid container alignItems="center">
          <Grid item>
            <ServiceProfileLink serviceSubscription={serviceSubscription} />
          </Grid>
          <Grid item>
            <Tooltip title={ts('common.service.unavailable')}>
              <InfoOutlinedIcon fontSize="inherit" style={{ marginLeft: 8 }} />
            </Tooltip>
          </Grid>
        </Grid>
    )
  } 
  else {
    return <ServiceProfileLink serviceSubscription={serviceSubscription} />
  }

}

export default CellService;
